import { Empty, Spin } from 'antd';
import IntentsTable from '../../Common/IntentsTable';
import MoneyDisplay from '../../Common/MoneyDisplay';

const groupMoneyType = (type) => {
  if (type === 'income') return 'INCOME';
  return 'EXPENSE';
};

const ProjectIntentsByCategoryView = ({ groupedData, loading, onIntentEdit, onIntentChanged }) => {
  if (loading) {
    return <div style={{ textAlign: 'center', padding: 40 }}><Spin /></div>;
  }
  if (!groupedData || groupedData.length === 0) {
    return <Empty description="Ni transakcij" />;
  }

  return (
    <>
      {groupedData.map((group) => (
        <div key={group.key} style={{ marginBottom: 50 }}>
          <h2 style={{ margin: 0, marginBottom: 8 }}>{group.title}</h2>
          <IntentsTable
            intentsData={{ results: group.intents }}
            onIntentEdit={onIntentEdit}
            onIntentChanged={onIntentChanged}
            setSelectedIds={() => {}}
            hidePagination
          />
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: 8,
              marginTop: 8,
              paddingRight: 8,
            }}
          >
            <strong>Skupaj:</strong>
            <MoneyDisplay
              size="small"
              type={groupMoneyType(group.type)}
              val={parseFloat(group.total) || 0}
            />
            <strong style={{ marginLeft: 16 }}>Skupaj brez DDV:</strong>
            <MoneyDisplay
              size="small"
              type={groupMoneyType(group.type)}
              val={parseFloat(group.total_no_tax) || 0}
            />
          </div>
          <hr />
        </div>
      ))}
    </>
  );
};

export default ProjectIntentsByCategoryView;
